import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../api/profile.service';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfirmedAccountGuard implements CanActivate {

  constructor(private profileServcie: ProfileService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.profileServcie.getGeneral(true).pipe(
      map(response => {
        return response.isEmailConfirmed && response.isPhoneConfirmed;
      }),
      tap(response => {
        if (!response) {
          this.router.navigate(['/setup']);
        }
      })
    );
  }
}
